import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import {
  GetTemplatesResponseTO,
  Template,
  TemplateType,
} from 'models/Templates';
import API from 'services/API';

export const TEMPLATE_BASE_QUERY_KEY = 'template';

type ReactQueryOptions = Omit<
  UseQueryOptions<Template>,
  'queryKey' | 'queryFn'
>;

type UseFetchTemplateArgs = {
  params: {
    agencyUid?: string;
    filled: boolean;
    leadUid?: string;
    name?: string;
    ownerUid?: string;
    propertyUid?: string;
    templateType: TemplateType;
    uid?: string;
  };
} & ReactQueryOptions;

const useFetchTemplate = ({
  params,
  enabled = true,
  ...options
}: UseFetchTemplateArgs) => {
  return useAppQuery<Template>({
    queryKey: [TEMPLATE_BASE_QUERY_KEY, 'detail', params],
    queryFn: async () => {
      const response = await API.get<GetTemplatesResponseTO>(`/v3/templates`, {
        params,
      });

      return response.data.templates[0];
    },
    enabled,
    keepPreviousData: true,
    ...(options ?? {}),
  });
};

export default useFetchTemplate;
